import React from 'react';
import ReactPlayer from 'react-player';
import ReactLoading from 'react-loading';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if';
import ScrollMenu from 'react-horizontal-scrolling-menu';

// import other components within the same project here

import SubmissionDetailStage from "composer/views/retriever/SubmissionDetailStage.jsx";
import CompareAnswerDialog from "composer/views/retriever/CompareAnswerDialog.jsx";
import StatisticsDialog from "composer/views/retriever/StatisticsDialog.jsx";
import Config from "composer/Config.jsx";
import Localization from "composer/Localization.jsx";
import Helper from "composer/Helper.jsx"
import PannellumVideoPlayer from "composer/views/stage/MoviePlayer/PannellumVideoPlayer.jsx";
import { PannellumVideo } from "pannellum-react";

import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Slider,
  FormControl,
  Select,
  MenuItem,
  Grid,
  CardActionArea,
  Icon,
  IconButton,
} from '@material-ui/core';
import { red } from '@material-ui/core/colors';

class HeatmapDetail extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      heatmapId: 0,
      heatmap_path: "",
      heatmap_json_path: "",

      // heatmap json data
      heatmapObj: null,
      UTCTimeStamp: [],
      UTCTimeStamp_controlPanelManipulation: [],
      UTCTimeStamp_tagInteractions: [],
      locale_id: 0,
      manipulationKind: [],
      multiplier: 0,
      stage_id: 0,
      tagInteractions: [],
      tagKind: [],
      tagRemarks: [],
      time_interval: 0,
      x_focus: [],
      y_focus: [],
      //

      tn_path: "",
      video_path: "",
      radius: 96,
      video_radius: 20,
      resolution: 171,
      alpha: 0.5,
      video_alpha: 0.5,
      video_mode: 0, // 0: standard, 1: filling
      normalize: 0,
      playedSeconds: 0,
    };
    autoBind(this);

    this.refresh();
  }

  reactPlayerOnProgress(data) {
    let playedSeconds = parseFloat(data.playedSeconds);
    this.setState({
      playedSeconds: playedSeconds,
    });
    this.state.playedSeconds = playedSeconds;

    for(let i = 0; i < this.state.UTCTimeStamp_controlPanelManipulation.length; i++){
      var currentSeconds = Helper.UTCTimestampSecondsBetween(this.state.UTCTimeStamp_controlPanelManipulation[i], this.state.UTCTimeStamp[0]);
      if(this.state.playedSeconds < currentSeconds){
        // scroll to this item
        this.refs.scrollMenuManipulation.state.translate = Math.min(0, -i+1)*180;
        break;
      }
    }

    for(let i = 0; i < this.state.UTCTimeStamp_tagInteractions.length; i++){
      var currentSeconds = Helper.UTCTimestampSecondsBetween(this.state.UTCTimeStamp_tagInteractions[i], this.state.UTCTimeStamp[0]);
      if(this.state.playedSeconds < currentSeconds){
        // scroll to this item
        this.refs.scrollMenuInteration.state.translate = Math.min(0, -i+1)*180;
        break;
      }
    }
  }

  scrollMenuManipulationCardClicked(triggerTime){
    this.refs.reactPlayer.seekTo(triggerTime, 'seconds');
  }

  scrollMenuInterationCardClicked(triggerTime){
    this.refs.reactPlayer.seekTo(triggerTime, 'seconds');
  }

  refresh() {
    if (this.state.heatmapId > 0) {
      this.setState({
        heatmap_path: "",
      });
      this.state.heatmap_path = "";
      this.props.root.refs.API.request("generate_heatmap_by_heatmap_id", {heatmap_id: this.state.heatmapId, radius: this.state.radius, resolution: this.state.resolution, alpha: this.state.alpha, normalize: this.state.normalize}, this.generateHeatmapOK, this.generateHeatmapFailed);
      this.props.root.refs.API.request("generate_heatmap_animation_by_heatmap_id", {heatmap_id: this.state.heatmapId, radius: this.state.video_radius, alpha: parseInt(this.state.video_alpha*255), mode: this.state.video_mode}, this.generateHeatmapAnimationOK, this.generateHeatmapFailed);

      // download the heatmap json by heatmap id
      this.props.root.refs.API.request("get_heatmap_json_path_by_heatmap_id", {heatmap_id: this.state.heatmapId}, this.getHeatmapJsonPathOK, this.getHeatmapJsonPathFailed);
    }
  }

  generateHeatmapOK(res) {
    this.setState({
      heatmap_path: res.body['result']['result_heatmap_path'],
      tn_path: res.body['result']['tn_path'],
    });
    this.state.heatmap_path = res.body['result']['result_heatmap_path'];
    this.state.tn_path = res.body['result']['tn_path'];
  }

  generateHeatmapAnimationOK(res) {
    this.setState({
      video_path: res.body['result']['result_heatmap_path'],
    });
    this.state.video_path = res.body['result']['result_heatmap_path'];
  }

  generateHeatmapFailed(err) {
    console.log("generateHeatmapFailed " + err);
  }

  getHeatmapJsonPathOK(res){
    this.setState({
      heatmap_json_path: res.body['result'],
    });
    this.state.heatmap_json_path = res.body['result'];

    // download json file here
    let json_url = Config.HOST_URL() + "heatmaps/" + this.state.heatmap_json_path;
    console.log(json_url);
    this.props.root.refs.API.request_get(json_url, this.onHeatmapJsonFetchedOK, this.onHeatmapJsonFetchedFailed)

  }

  onHeatmapJsonFetchedOK(res){
    // start decoding heatmap json here
    console.log("onHeatmapJsonFetchedOK");

    this.setState({
      heatmapObj: res.body,
      UTCTimeStamp: res.body.UTCTimeStamp,
      UTCTimeStamp_controlPanelManipulation: res.body.UTCTimeStamp_controlPanelManipulation,
      UTCTimeStamp_tagInteractions: res.body.UTCTimeStamp_tagInteractions,
      locale_id: res.body.locale_id,
      manipulationKind: res.body.manipulationKind,
      multiplier: res.body.multiplier,
      stage_id: res.body.stage_id,
      tagInteractions: res.body.tagInteractions,
      tagKind: res.body.tagKind,
      tagRemarks: res.body.tagRemarks,
      time_interval: res.body.time_interval,
      x_focus: res.body.x_focus,
      y_focus: res.body.y_focus,
    });
    this.state.heatmapObj = res.body;
    this.state.UTCTimeStamp = res.body.UTCTimeStamp;
    this.state.UTCTimeStamp_controlPanelManipulation = res.body.UTCTimeStamp_controlPanelManipulation;
    this.state.UTCTimeStamp_tagInteractions = res.body.UTCTimeStamp_tagInteractions;
    this.state.locale_id = res.body.locale_id;
    this.state.manipulationKind = res.body.manipulationKind;
    this.state.multiplier = res.body.multiplier;
    this.state.stage_id = res.body.stage_id;
    this.state.tagInteractions = res.body.tagInteractions;
    this.state.tagKind = res.body.tagKind;
    this.state.tagRemarks = res.body.tagRemarks;
    this.state.time_interval = res.body.time_interval;
    this.state.x_focus = res.body.x_focus;
    this.state.y_focus = res.body.y_focus;

    console.log(this.state.heatmapObj);
    console.log(this.state.manipulationKind);
  }

  onHeatmapJsonFetchedFailed(err){
    console.log("onHeatmapJsonFetchedFailed");
  }

  getHeatmapJsonPathFailed(err){
    console.log("download heatmap json failed");
  }

  radiusOnChange = (event, value) => {
    this.setState({
      radius: value,
    })
    this.state.radius = value;
  }

  videoRadiusOnChange = (event, value) => {
    this.setState({
      video_radius: value,
    })
    this.state.video_radius = value;
  }

  resolutionOnChange = (event, value) => {
    this.setState({
      resolution: value,
    })
    this.state.resolution = value;
  }

  alphaOnChange = (event, value) => {
    this.setState({
      alpha: value,
    })
    this.state.alpha = value;
  }

  videoAlphaOnChange = (event, value) => {
    this.setState({
      video_alpha: value,
    })
    this.state.video_alpha = value;
  }

  processHeatmapClicked() {
    this.setState({
      heatmap_path: "",
    });
    this.state.heatmap_path = "";
    this.refresh();
  }

  processVideoHeatmapClicked(){
    this.setState({
      video_path: "",
    });
    this.state.video_path = "";
    this.refresh();
  }

  onVideoModeChanged(e){
    this.setState({
      video_mode: e.target.value,
    });
    this.state.video_mode = e.target.value;
  }

  render() {
    // return (
    //   <div style={{maxHeight:this.props.maxHeight, overflow:'auto'}}>
    //     <CompareAnswerDialog root={this.props.root} parent={this} ref="compareAnswerDialog"/>
    //     <StatisticsDialog root={this.props.root} parent={this} ref="statisticsDialog"/>

    //     {this.state.stageList.map( (row, i) => {
    //       return (
    //         <SubmissionDetailStage parent={this} root={this.props.root}
    //           stageData={row['stage_detail']}
    //           answerDataList={row['answer_list']}
    //           key={row['stage_detail']['id']}
    //         />
    //       );
    //     })}
    //   </div>
    // )
    return (
      <div style={{margin:"0 32px 16px 32px"}}>
        <If condition={this.state.heatmapId != 0}>
          <Then>
            <Card style={{margin:"0 16px 16px 0"}}>
              <CardHeader
                title="Heat Map"
              />
              <div style={{padding:"32px 32px 32px 32px"}}>
                <If condition={this.state.heatmap_path != ""}>
                  <Then>
                    <img width="100%" src={Config.HOST_URL() + this.state.tn_path} alt={this.state.tn_path.replace(/^.*[\\\/]/, '')}></img>
                    <img width="100%" src={Config.HOST_URL() + this.state.heatmap_path} alt={this.state.heatmap_path.replace(/^.*[\\\/]/, '')}></img>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={2}>
                        {Localization.strings.HEATMAP_RADIUS}
                      </Grid>
                      <Grid item xs={12} sm={10}>
                        <Slider
                          value={this.state.radius}
                          min={2}
                          max={96}
                          step={2}
                          valueLabelDisplay="auto"
                          marks={[{value: 2, label: '2'}, {value: 96, label: '96'}]}
                          onChange={this.radiusOnChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        {Localization.strings.HEATMAP_RESOLUTION}
                      </Grid>
                      <Grid item xs={12} sm={10}>
                        <Slider
                          value={this.state.resolution}
                          min={171}
                          max={671}
                          step={10}
                          valueLabelDisplay="auto"
                          marks={[{value: 171, label: '171'}, {value: 671, label: '671'}]}
                          onChange={this.resolutionOnChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        {Localization.strings.HEATMAP_ALPHA}
                      </Grid>
                      <Grid item xs={12} sm={10}>
                        <Slider
                          value={this.state.alpha}
                          min={0.1}
                          max={1}
                          step={0.1}
                          valueLabelDisplay="auto"
                          marks={[{value: 0.1, label: '0.1'}, {value: 1, label: '1'}]}
                          onChange={this.alphaOnChange}
                        />
                      </Grid>
                    </Grid>
                    <Button
                      style={{margin: "10px"}}
                      color="primary"
                      variant="contained"
                      onClick={this.processHeatmapClicked}
                    >
                      {Localization.strings.UPDATE}
                    </Button>
                    <a href={Config.HOST_URL() + this.state.heatmap_path} download target="_blank" style={{textDecoration: 'none'}}>
                      <Button
                        color="primary"
                        variant="contained"
                      >
                        {Localization.strings.DOWNLOAD}
                      </Button>
                    </a>
                  </Then>
                  <Else>
                    <ReactLoading type="balls" color="#E33E7F" 
                      height={100} width={50} />
                  </Else>
                </If>
              </div>
            </Card>
            <Card style={{margin:"0 16px 16px 0"}}>
              <CardHeader
                title="Observation Path"
              />
              <div style={{padding:"32px 32px 32px 32px"}}>
                <If condition={this.state.video_path != ""}>
                  <Then>
                    <ReactPlayer
                      ref="reactPlayer"
                      width="100%"
                      height="100%"
                      url={Config.HOST_URL() + this.state.video_path}
                      playing={false}
                      controls={true}
                      playsinline={true}
                      onProgress={this.reactPlayerOnProgress}
                      progressInterval={50}
                    />
                    
                    <Typography>
                      Stage Control
                    </Typography>
                    <div style={{height:'90px'}} ref="div">
                      <ScrollMenu
                        ref="scrollMenuManipulation"
                        style={{height:'70px'}}
                        data={
                          this.state.manipulationKind.map((row, i) => {
                            var triggerTime = Helper.UTCTimestampSecondsBetween(this.state.UTCTimeStamp_controlPanelManipulation[i], this.state.UTCTimeStamp[0]);
                            return(
                              <div style={{padding:'1px 14px 6px 1px'}} key={i}>
                                <Card style={{backgroundColor:(triggerTime >= this.state.playedSeconds)?"":"#6EFF6E"}}>
                                  <CardActionArea
                                    onClick={()=>this.scrollMenuManipulationCardClicked(triggerTime)}
                                  >
                                    <CardContent>
                                      <Typography>
                                        {Config.GET_MANIPULATION_KIND(row)}
                                      </Typography>
                                      <Typography>
                                        {"Trigger Time: " + Helper.fToHHMMSS(triggerTime)}
                                      </Typography>
                                    </CardContent>
                                  </CardActionArea>
                                </Card>
                              </div>
                            );
                          })
                        }
                        arrowLeft={<IconButton><Icon>keyboard_arrow_left</Icon></IconButton>}
                        arrowRight={<IconButton><Icon>keyboard_arrow_right</Icon></IconButton>}
                        hideArrows={true}
                        hideSingleArrow={true}
                        alignCenter={false}
                      />
                    </div>

                    <Typography>
                      Tag Interaction
                    </Typography>
                    <div style={{height:'90px'}} ref="div">
                      <ScrollMenu
                        ref="scrollMenuInteration"
                        style={{height:'70px'}}
                        data={
                          this.state.tagInteractions.map((row, i) => {
                            var triggerTime = Helper.UTCTimestampSecondsBetween(this.state.UTCTimeStamp_tagInteractions[i], this.state.UTCTimeStamp[0]);
                            return(
                              <div style={{padding:'1px 14px 6px 1px'}} key={i}>
                                <Card style={{backgroundColor:(triggerTime >= this.state.playedSeconds)?"":"#6EFF6E"}}>
                                  <CardActionArea
                                    onClick={()=>this.scrollMenuInterationCardClicked(triggerTime)}
                                  >
                                    <CardContent>
                                      <Typography>
                                        {Config.GET_INTERACTION_KIND(row)}
                                      </Typography>
                                      <Typography>
                                        {"Trigger Time: " + Helper.fToHHMMSS(triggerTime)}
                                      </Typography>
                                    </CardContent>
                                  </CardActionArea>
                                </Card>
                              </div>
                            );
                          })
                        }
                        arrowLeft={<IconButton><Icon>keyboard_arrow_left</Icon></IconButton>}
                        arrowRight={<IconButton><Icon>keyboard_arrow_right</Icon></IconButton>}
                        hideArrows={true}
                        hideSingleArrow={true}
                        alignCenter={false}
                      />
                    </div>

                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={2}>
                        {Localization.strings.HEATMAP_RADIUS}
                      </Grid>
                      <Grid item xs={12} sm={10}>
                        <Slider
                          value={this.state.video_radius}
                          min={2}
                          max={96}
                          step={2}
                          valueLabelDisplay="auto"
                          marks={[{value: 2, label: '2'}, {value: 96, label: '96'}]}
                          onChange={this.videoRadiusOnChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        {Localization.strings.HEATMAP_ALPHA}
                      </Grid>
                      <Grid item xs={12} sm={10}>
                        <Slider
                          value={this.state.video_alpha}
                          min={0.1}
                          max={1}
                          step={0.1}
                          valueLabelDisplay="auto"
                          marks={[{value: 0.1, label: '0.1'}, {value: 1, label: '1'}]}
                          onChange={this.videoAlphaOnChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        {Localization.strings.HEATMAP_ANIMATION_MODE}
                      </Grid>
                      <Grid item xs={12} sm={10}>
                        <FormControl>
                          <Select
                            value={this.state.video_mode}
                            onChange={this.onVideoModeChanged}
                          >
                            <MenuItem value={0}>{Localization.strings.HEATMAP_ANIMATION_MODE_STANDARD}</MenuItem>
                            <MenuItem value={1}>{Localization.strings.HEATMAP_ANIMATION_MODE_FILLING_MODE}</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Button
                      style={{margin: "10px"}}
                      color="primary"
                      variant="contained"
                      onClick={this.processVideoHeatmapClicked}
                    >
                      {Localization.strings.UPDATE}
                    </Button>
                    <a href={Config.HOST_URL() + this.state.video_path} download target="_blank" style={{textDecoration: 'none'}}>
                      <Button
                        color="primary"
                        variant="contained"
                        // onClick={this.saveHeatmapClicked}
                      >
                        {Localization.strings.DOWNLOAD}
                      </Button>
                    </a>
                  </Then>
                  <Else>
                    <ReactLoading type="balls" color="#E33E7F" 
                      height={100} width={50} />
                  </Else>
                </If>
              </div>
            </Card>
          </Then>
        </If>
      </div>
    )
  }
}

export default HeatmapDetail;
